import React from 'react';

interface DescriptionProps {
    description: string;
}

const Description: React.FC<DescriptionProps> = ({ description }) => (
    <p>{description}</p>
);

export default Description;